import styled from 'styled-components'
import ClearButton from './Button/ClearButton'
import SearchButton from './Button/SearchButton'
import WorksCount from './WorksCount'

interface PropsType {
  searchUrl: string
  worksCount: number
  onClickClearButton: () => void
}

const SearchControlBoxWrapper = styled.div`
  align-items: center;
  display: flex;
`

const ControlClearButton = styled(ClearButton)`
  margin-left: 15px;
`

const SearchControlBox = (props: PropsType) => {
  const { searchUrl, worksCount, onClickClearButton } = props

  return (
    <SearchControlBoxWrapper>
      <WorksCount count={worksCount} />
      <SearchButton searchUrl={searchUrl} />
      <ControlClearButton onClick={onClickClearButton}>すべてクリア</ControlClearButton>
    </SearchControlBoxWrapper>
  )
}

export default SearchControlBox
